import { registerComponent, asyncRequest, loading } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "product-form",
  class ProductForm extends WYATTElement {
    SECTIONS_TO_RENDER = [
      {
        name: "cart-count",
        liveRegion: "cart-count",
      },
      {
        name: "cart",
        liveRegion: "free-shipping-message",
      },
      {
        name: "cart",
        liveRegion: "cart-items",
      },
      {
        name: "cart",
        liveRegion: "cart-totals",
      },
      {
        name: "cart",
        liveRegion: "cart-checkout",
      },
      {
        name: "cart",
        liveRegion: "cart-recommendations",
      },
    ];

    constructor() {
      super();

      this.form = this.querySelector("form");
      this.form.addEventListener("submit", this.handleSubmit.bind(this));
    }

    handleSubmit(event) {
      event.preventDefault();

      loading.add(this);
      this.addToCart();
    }

    getSectionNames() {
      return [
        ...new Set(this.SECTIONS_TO_RENDER.map((section) => section.name)),
      ];
    }

    getBody() {
      const formData = new FormData(this.form);

      const propertiesRegex = /properties\[(.*?)\]/;
      const attributesRegex = /attributes\[(.*?)\]/;

      const body = {
        items: [
          {
            id: formData.get("id"),
            quantity: formData.get("quantity"),
            properties: {},
          },
        ],
        sections: this.getSectionNames(),
        attributes: {},
      };

      // Add cart attributes or line item properties to body
      Array.from(formData).forEach(([name, value]) => {
        const propertiesMatch = propertiesRegex.exec(name);
        const attributesMatch = attributesRegex.exec(name);

        if (propertiesMatch && propertiesMatch.length > 1) {
          body.items[0].properties[propertiesMatch[1]] = value;
        }

        if (attributesMatch && attributesMatch.length > 1) {
          body.attributes[attributesMatch[1]] = value;
        }
      });

      return body;
    }

    async addToCart() {
      const body = this.getBody();
      const options = {
        ...WYATT.config.fetch.post,
        ...{ body: JSON.stringify(body) },
      };

      const addedToCartResponse = await asyncRequest(
        `${WYATT.routes.cart_add_url}.js`,
        options,
        {
          messageOptions: {
            minDelay: 6000,
            appendPoint:
              "[data-mini-cart] [data-dialog-messages], #page-messages",
          },
        }
      );

      if (addedToCartResponse) {
        this.handleSuccessfulAdd(addedToCartResponse);
      } else {
        this.handleUnsuccessfulAdd();
      }

      loading.remove(this);
    }

    handleSuccessfulAdd(response) {
      const data = JSON.parse(response);

      this.updateSections(data.sections);
      this.publish(WYATT.config.pubsub.events.addToCart);
    }

    async handleUnsuccessfulAdd() {
      const sectionsData = await asyncRequest(
        `${window.location.pathname}?sections=${this.getSectionNames()}`,
        {},
        {
          responseFormat: "json",
        }
      );

      if (sectionsData) {
        this.updateSections(sectionsData);
      }

      this.publish(WYATT.config.pubsub.events.addToCart);
    }

    updateSections(data) {
      this.publish(
        WYATT.config.pubsub.events.updateDOM,
        this.SECTIONS_TO_RENDER.map(({ liveRegion, name }) => ({
          liveRegion,
          html: data[name],
        }))
      );
    }
  }
);
